import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertController, ModalController } from '@ionic/angular';
import { Camera } from '@capacitor/camera';

import { GlobalService } from './global.service';
import { I18nService } from './shared/i18n.service';

@Injectable({
    providedIn: 'root'
})
export class CameraService {

    constructor(
        private snackBar: MatSnackBar,
        public alertController: AlertController,
        public modalController: ModalController,
        private global: GlobalService,
        private i18n: I18nService,
    ) { }

    async showPopoverCameraRights() {
        const alert = await this.alertController.create({
            header: this.i18n.tr('[en]Camera permissions'),
            message:
                this.i18n.tr('[en]Please allow the camera and photos permissions to use this feature.'),
            buttons: [
                {
                    text: this.i18n.tr('[en]Cancel'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {},
                },
                {
                    text: 'Allow',
                    handler: () => {},
                },
            ],
        });
        await alert.present();
    }

    async startCamera() {
        if (this.global.MyPlatform === 'web') {
            console.log('Camera not available on web platform');
            this.snackBar.open(
                this.i18n.tr('Geen camera toegang via web versie.'),
                'OK', {
                    duration: 1000,
            });
            return false;
        }
        const permissions = await Camera.requestPermissions();
        if (
            permissions.photos === 'denied' ||
            permissions.camera === 'denied'
        ) {
            //Popover asking them to click `Allow` on the native permission dialog
            await this.showPopoverCameraRights();
            const permissions = await Camera.requestPermissions();
            if (
                permissions.photos === 'denied' ||
                permissions.camera === 'denied'
            ) {
                console.log('Camera permission not granted');
                this.snackBar.open(this.i18n.tr('Geen rechten voor camera gebruik.'), 'OK', {
                    duration: 1000,
                });
                return false;
            }
        }
        return true;
    }

}
